export default "__VITE_ASSET__Dco0OXLz__"